export enum SettlementStatus {
  ToBeSettled = 'ToBeSettled',
  Settled = 'Settled',
  SettledAutomatically = 'SettledAutomatically',
}
